import moment from 'moment';

export default {
    methods: { moment }
}